import { render } from "./InboxView.vue?vue&type=template&id=600ed5e2"
import script from "./InboxView.vue?vue&type=script&lang=js"
export * from "./InboxView.vue?vue&type=script&lang=js"

import "./InboxView.vue?vue&type=style&index=0&id=600ed5e2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__